exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".frontpage-splash {\n  padding: 8em 0 10em 0; }\n  .frontpage-splash h2 {\n    font-style: italic; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/src/app/pages/frontpage/frontpage.component.scss
// module id = ../../../../../src/app/pages/frontpage/frontpage.component.scss
// module chunks = 0